// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/core.scss
// module id = 374
// module chunks = 0